import { Events } from 'global/constants';
import { storeChanged } from './addressUtility';

const { OdSelect } = window.od;

export default class SelectObserver {
	constructor(storeInstance, selectElementReference) {
		this.init(selectElementReference);
		storeInstance.subscribe(this.storeChanged.bind(this));
	}

	storeChanged(event) {
		storeChanged(event, this.updateAddressList.bind(this));
	}

	updateAddressList(newAddressList) {
		this.addressList = newAddressList;
	}

	init(selectElementReference) {
		this.element = document.querySelector(`[name="${selectElementReference}"]`);

		if (this.element) {
			const odSelect = 'od-select';
			this.selectChoice = new OdSelect(this.element, {
				searchPlaceholderValue: '',
				noResultsText: '',
				classNames: {
					containerOuter: `checkout-select-address ${odSelect} `,
					containerInner: `${odSelect}__inner`,
					input: `${odSelect}__input`,
					inputCloned: `${odSelect}__input--cloned`,
					list: `${odSelect}__list`,
					listItems: `${odSelect}__list--multiple`,
					listSingle: `${odSelect}__list--single`,
					listDropdown: `${odSelect}__list--dropdown`,
					item: `${odSelect}__item`,
					itemSelectable: `${odSelect}__item--selectable`,
					itemDisabled: `${odSelect}__item--disabled`,
					itemChoice: `${odSelect}__item--choice`,
					placeholder: `${odSelect}__placeholder`,
					group: `${odSelect}__group`,
					groupHeading: `${odSelect}__heading`,
					button: `${odSelect}__button`,
					isActiveModifier: '--is-active',
				},
			});
			this.selectChoice.addEventListener(
				Events.CHOICES_CHOICE,
				this.update.bind(this),
			);
			this.remapChoices(window.od.deliveryAddress);
		}
	}

	update(event) {
		const foundAddress =
			this.addressList instanceof Array
				? this.addressList.find(
						address => address.id === event.detail.choice.value,
					)
				: null;
		if (foundAddress && !foundAddress.selected) {
			const updatedAddressSelection = this.remapAddresses(event);
			this.remapChoices(updatedAddressSelection);
			window.od.events.publish(Events.ADDRESS_STORE_UPDATE, {
				payload: updatedAddressSelection,
			});
		}
	}

	remapAddresses(event) {
		// eslint-disable-next-line array-callback-return
		return this.addressList.map(address => {
			const isSelected = address.id === event.detail.choice.value;
			const updatedAddress = Object.assign({}, address);
			updatedAddress.selected = isSelected;
			updatedAddress.disabled = isSelected;
			return updatedAddress;
		});
	}

	remapChoices(choiceList) {
		// eslint-disable-next-line arrow-body-style
		const newChoiceList = choiceList.map(address => {
			return {
				label: this.formatAddress(address),
				value: address.id,
				selected: false,
				disabled: address.disabled,
			};
		});
		const defaultSelection = [
			{
				label: this.element.getAttribute('data-choices-default-option'),
				value: 'default',
			},
		];

		const concatChoiceList = defaultSelection.concat(newChoiceList);

		setTimeout(this.applyChoices.bind(this, concatChoiceList), 0);

		return concatChoiceList;
	}

	formatAddress(address) {
		let postCodeAndTown = '';

		if (
			address.town &&
			address.postalCode &&
			['GB', 'IE'].includes(address.isocode)
		) {
			postCodeAndTown = [address.town, address.postalCode];
		} else if (address.town && address.postalCode) {
			postCodeAndTown = `${address.postalCode} ${address.town}`;
		} else if (address.town) {
			postCodeAndTown = address.town;
		} else if (address.postalCode) {
			postCodeAndTown = address.postalCode;
		}

		return (
			[
				address.contactName,
				address.companyName,
				address.line1,
				address.line2,
				postCodeAndTown,
				address.country,
				address.desktopDeliveryMessage,
			]
				.flat()
				.filter(addressLine => Boolean(addressLine))
				// eslint-disable-next-line
				.map(addressLine =>
					typeof addressLine === 'string'
						? addressLine.replace(/ +/g, '&nbsp;')
						: '',
				)
				.join(', ')
		);
	}

	applyChoices(choiceList) {
		if (this.selectChoice) {
			this.selectChoice.initComponent.setChoices(
				choiceList,
				'value',
				'label',
				true,
			);
			this.selectChoice.initComponent.setChoiceByValue('default');
		}
	}
}
